import React, { useEffect, useState } from "react";
import { set, useForm } from "react-hook-form";
import { Container, Row, Col } from "react-bootstrap";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import axios from "axios";
import ReactTost from "../ReactTost";

import BtnLoader from "../BtnLoader";
import { useTranslation } from "react-i18next";

export default function Setting() {
  const API_URL = process.env.REACT_APP_API_URL;
  const API_VERSION = process.env.REACT_APP_API_VERSION;
  const { t } = useTranslation();
  const {
    handleSubmit,
    register,
    formState: { errors },
    setValue,
  } = useForm();
  const [loading, setLoading] = useState(false);
  const [addOnsloading, setAddOnsloading] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [type, setType] = useState("");
  const [message, setMessage] = useState("");
  const [updateId, setUpdateId] = useState(0);
  const [addOnsUpdateId, setAddOnsUpdateId] = useState(0);
  const [prompt, setPrompt] = useState("");
  const [model, setModel] = useState("");
  const [visibility, setVisibility] = useState("");
  const [messageLimit, setMessageLimit] = useState("");
  const [bubbleName, setBubbleName] = useState("");
  const [initialMsg, setInitialMsg] = useState("");
  const [logoName, setlogoName] = useState("");
  const [color, setColor] = useState("");
  const [headerColor, setHeaderColor] = useState("");
  const [btnAlign, setBtnAlign] = useState("");
  const [messageType, setMessageType] = useState("");
  const [addMsg, setAddMsg] = useState("");
  const [price, setPrice] = useState("");

  function changeLogoName(e) {
    const reader = new FileReader();
    reader.onloadend = () => {
      setlogoName(reader.result);
    };
    reader.readAsDataURL(e.target.files[0]);
  }

  async function settingForm(data) {
    if (updateId) {
      setLoading(true);
      if (logoName) {
        data.file = logoName;
      }
      await axios
        .put(`${API_URL}/${API_VERSION}/bot/form/${updateId}`, data, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        })
        .then((response) => {
          setLoading(false);
          setType("Success");
          setMessage(t("Your bot is updated."));
          setShowAlert(true);
        })
        .catch(() => {
          setLoading(false);
          setType("Danger");
          setMessage(t("Something went to wrong."));
          setShowAlert(true);
        });
    } else {
      setLoading(true);
      await axios
        .post(
          `${API_URL}/${API_VERSION}/bot/form/`,
          {
            prompt: data.prompt,
            model: data.model,
            visibility: data.visibility,
            messageLimit: data.messageLimit,
            logoName,
            bubbleName: data.bubbleName,
            initialMsg: data.initialMsg,
            // logoName:logoName,
            color: data.color,
            headerColor: data.headerColor,
            btnAlign: data.btnAlign,
            messageType: data.messageType,
          },
          {
            headers: {
              accept: "application/json",
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        )
        .then(() => {
          setType("Success");
          setMessage(t("Your data is send."));
          setShowAlert(true);
          setLoading(false);
        })
        .catch((error) => {
          setLoading(false);
          console.error("Error sending data:", error);
          setType("Danger");
          setMessage(t("Something went to wrong."));
          setShowAlert(true);
        });
    }
  }

  async function getSettingData() {
    setLoading(true);
    // Defult Data
    await axios
      .get(`${API_URL}/${API_VERSION}/bot/form/`, {
        headers: {
          accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
      .then((response) => {
        setLoading(false);
        if (response.data.length) {
          setUpdateId(response.data[0].id);
          setValue("prompt", response.data[0].prompt);
          setValue("model", response.data[0].model);
          setValue("visibility", response.data[0].visibility);
          setValue("messageLimit", response.data[0].messageLimit);
          setValue("headerLogo", response.data[0].headerLogo);
          setValue("bubbleName", response.data[0].bubbleName);
          setValue("logoName", response.data[0].logoName);
          setValue("initialMsg", response.data[0].initialMsg);
          setValue("color", response.data[0].color);
          setValue("headerColor", response.data[0].headerColor);
          setValue("btnAlign", response.data[0].btnAlign);
          setValue("messageType", response.data[0].messageType);
        }
      })
      .catch((error) => {
        setLoading(false);
        console.log(error);
      });
  }

  useEffect(() => {
    getSettingData();
  }, []);


  async function getAddons(data) {
    if (addOnsUpdateId) {
      setAddOnsloading(true);
      axios
        .patch(
          `${API_URL}/${API_VERSION}/planAddOn/${addOnsUpdateId}`,
          {
            price: data.price,
            messageLimit: data.addMsg,
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        )
        .then((response) => {
          setAddOnsloading(false);
          setType("Success");
          setMessage(t("Addons updated successfully"));
          showAlert(true);
        })
        .catch(() => {
          setAddOnsloading(false);
        });
    } else {
      await axios
        .post(
          `${API_URL}/${API_VERSION}/planAddOn`,
          {
            price: data.price,
            messageLimit: data.addMsg,
          },
          {
            headers: {
              accept: "application/json",
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        )
        .then((response) => {
          setType("Success");
          setMessage(t("Addons added successfully."));
          setShowAlert(true);
          setAddOnsloading(false);
        })
        .catch((error) => {
          setAddOnsloading(false);
          console.error("Error sending data:", error);
          setType("Danger");
          setMessage(t("Something went to wrong."));
          setShowAlert(true);
        });
    }
  }

  // Plan AddOns get data
  useEffect(() => {
    setAddOnsloading(true);
    axios
      .get(`${API_URL}/${API_VERSION}/planAddOn/`, {
        headers: {
          accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
      .then((response) => {
        setAddOnsloading(false);
        console.log(response.data[0]);
        setAddOnsUpdateId(response.data[0].id);
        setValue("addMsg", response.data[0].messageLimit);
        setValue("price", response.data[0].price);
      })
      .catch((error) => {
        setAddOnsloading(false);
        console.log(error);
      });
  }, []);

  return (
    <>
      <section id="default_setting" className="mb-4">
        <ReactTost
          onHide={() => {
            setShowAlert(false);
            setType("");
            setMessage("");
          }}
          alertClass={type}
          alertMessage={message}
          alertDo={showAlert}
        />
        <Container>
          {/* {loading ? <Loader/>: */}
          <Row className="justify-content-center">
            <Col lg={8}>
              <div className="boxwrap">
                <form onSubmit={handleSubmit(settingForm)}>
                  <Row className="justify-content-center">
                    <Col lg={12}>
                      <div className="form-group">
                        <div className="d-flex align-items-center justify-content-between mb-2">
                          <label className="form-label mb-0">
                            {t("Base Prompt (system message)")}
                            <OverlayTrigger
                              key="right"
                              placement="right"
                              overlay={
                                <Tooltip>{t("Base Prompt info")}</Tooltip>
                              }
                            >
                              <span className="ms-2 text-orange">
                                <i className="fa-solid fa-circle-question"></i>
                              </span>
                            </OverlayTrigger>
                          </label>
                        </div>
                        <textarea
                          className={`form-control ${
                            errors.prompt ? "is-invalid" : ""
                          }`}
                          rows="3"
                          id="prompt"
                          name="prompt"
                          // value={prompt}
                          {...register("prompt", {
                            required: "This field is required",
                          })}
                          onChange={(event) => {
                            setPrompt(event.target.value);
                          }}
                        />
                        {errors.prompt && (
                          <span className="invalid-feedback">
                            {errors.prompt.message}
                          </span>
                        )}
                      </div>
                      <div className="form-group">
                        <label className="form-label">
                          {t("Model")}
                          <OverlayTrigger
                            key="right"
                            placement="right"
                            overlay={<Tooltip>{t("model info")}</Tooltip>}
                          >
                            <span className="ms-2 text-orange">
                              <i className="fa-solid fa-circle-question"></i>
                            </span>
                          </OverlayTrigger>
                        </label>
                        <select
                          className={`form-select ${
                            errors.model ? "is-invalid" : ""
                          }`}
                          aria-label="Default select example"
                          id="model"
                          name="model"
                          // value={model}
                          {...register("model", {
                            required: "Please select an option",
                          })}
                          onChange={(event) => {
                            setModel(event.target.value);
                          }}
                        >
                          <option>{t("Open this select menu")}</option>
                          <option value="gpt-3.5-turbo">
                            {t("gpt-3.5-turbo")}
                          </option>
                          <option value="gpt-4">{t("gpt-4")}</option>
                        </select>
                        {errors.model && (
                          <span className="invalid-feedback">
                            {errors.model.message}
                          </span>
                        )}
                      </div>
                      <div className="form-group">
                        <label className="form-label">
                          {t("Visibility")}
                          <OverlayTrigger
                            key="right"
                            placement="right"
                            overlay={<Tooltip>{t("Visibility info")}</Tooltip>}
                          >
                            <span className="ms-2 text-orange">
                              <i className="fa-solid fa-circle-question"></i>
                            </span>
                          </OverlayTrigger>
                        </label>
                        <select
                          className={`form-select ${
                            errors.visibility ? "is-invalid" : ""
                          }`}
                          aria-label="Default select"
                          name="visibility"
                          id="visibility"
                          // value={visibility}
                          {...register("visibility", {
                            required: "Please select an option",
                          })}
                          onChange={(event) => {
                            setVisibility(event.target.value);
                          }}
                        >
                          <option>{t("Open this select menu")}</option>
                          <option value="public">{t("Public")}</option>
                          <option value="private">{t("Private")}</option>
                        </select>
                        {errors.visibility && (
                          <span className="invalid-feedback">
                            {errors.visibility.message}
                          </span>
                        )}
                      </div>
                      <div className="form-group">
                        <label className="form-label">
                          {t("Max Questions per visitor")}
                          <OverlayTrigger
                            key="right"
                            placement="right"
                            overlay={
                              <Tooltip>
                                {t("Max Questions per visitor info")}
                              </Tooltip>
                            }
                          >
                            <span className="ms-2 text-orange">
                              <i className="fa-solid fa-circle-question"></i>
                            </span>
                          </OverlayTrigger>
                        </label>
                        <input
                          className={`form-control ${
                            errors.messageLimit ? "is-invalid" : ""
                          }`}
                          type="number"
                          name="messageLimit"
                          id="messageLimit"
                          // value={messageLimit}
                          {...register("messageLimit", {
                            required: "This field is required",
                          })}
                          onChange={(event) =>
                            setMessageLimit(event.target.value)
                          }
                        />
                        {errors.messageLimit && (
                          <span className="invalid-feedback">
                            {errors.messageLimit.message}
                          </span>
                        )}
                      </div>
                      <div className="form-group">
                        <label className="form-label">
                          {t("Bubble Text")}
                          <OverlayTrigger
                            key="right"
                            placement="right"
                            overlay={<Tooltip>{t("Bubble Text Info")}</Tooltip>}
                          >
                            <span className="ms-2 text-orange">
                              <i className="fa-solid fa-circle-question"></i>
                            </span>
                          </OverlayTrigger>
                        </label>
                        <input
                          className={`form-control ${
                            errors.bubbleName ? "is-invalid" : ""
                          }`}
                          type="text"
                          name="bubbleName"
                          id="bubbleName"
                          // value={bubbleName}
                          {...register("bubbleName", {
                            required: "This field is required",
                          })}
                          onChange={(event) => {
                            setBubbleName(event.target.value);
                          }}
                        />
                        {errors.bubbleName && (
                          <span className="invalid-feedback">
                            {errors.bubbleName.message}
                          </span>
                        )}
                      </div>
                      <div className="form-group">
                        <label className="form-label">
                          {t("Initial Welcome Message")}
                          <OverlayTrigger
                            key="right"
                            placement="right"
                            overlay={
                              <Tooltip>
                                {t("Initial Welcome Message Info")}
                              </Tooltip>
                            }
                          >
                            <span className="ms-2 text-orange">
                              <i className="fa-solid fa-circle-question"></i>
                            </span>
                          </OverlayTrigger>
                        </label>
                        <input
                          className={`form-control ${
                            errors.initialMsg ? "is-invalid" : ""
                          }`}
                          type="text"
                          name="initialMsg"
                          id="initialMsg"
                          // value={initialMsg}
                          {...register("initialMsg", {
                            required: "This field is required.",
                          })}
                          onChange={(event) => {
                            setInitialMsg(event.target.value);
                          }}
                        />
                        {errors.initialMsg && (
                          <span className="invalid-feedback">
                            {errors.initialMsg.message}
                          </span>
                        )}
                      </div>
                      <div className="form-group">
                        <label className="form-label">
                          {t("Chat Bot Image")}
                          <OverlayTrigger
                            key="right"
                            placement="right"
                            overlay={
                              <Tooltip>{t("Chat bot Image Info")}</Tooltip>
                            }
                          >
                            <span className="ms-2 text-orange">
                              <i className="fa-solid fa-circle-question"></i>
                            </span>
                          </OverlayTrigger>
                        </label>
                        <div className="setting_img_preview">
                          <input
                            className={`form-control ${
                              errors.logoName ? "is-invalid" : ""
                            }`}
                            type="file"
                            id="logoName"
                            name="logoName"
                            // value={logoName}
                            accept="image/*"
                            {...register("logoName")}
                            onChange={(event) => {
                              changeLogoName(event);
                            }}
                          />
                          <div className="chat_icon">
                            <div className="icon">
                              <img
                                src={
                                  logoName
                                    ? logoName
                                    : "https://seekicon.com/free-icon-download/chat_7.svg"
                                }
                                alt=""
                              />
                            </div>
                          </div>
                        </div>
                        {errors.logoName && (
                          <span className="invalid-feedback">
                            {errors.logoName.message}
                          </span>
                        )}
                      </div>
                      <div className="form-group">
                        <label className="form-label" htmlFor="">
                          {t("Header Color")}
                          <OverlayTrigger
                            key="right"
                            placement="right"
                            overlay={
                              <Tooltip>{t("Header Color info")}</Tooltip>
                            }
                          >
                            <span className="ms-2 text-orange">
                              <i className="fa-solid fa-circle-question"></i>
                            </span>
                          </OverlayTrigger>
                        </label>
                        <div className="d-flex align-items-center justify-content-start gap-3">
                          <input
                            type="color"
                            className={`form-control form-control-color ${
                              errors.colorInput ? "is-invalid" : ""
                            }`}
                            id="headerColor"
                            name="headerColor"
                            // value={color}
                            title="Choose your color"
                            {...register("headerColor", {
                              required: "Please select the header color.",
                            })}
                            onChange={(event) => {
                              setColor(event.target.value);
                            }}
                          />
                          {errors.color && (
                            <span className="invalid-feedback">
                              {errors.headerColor.message}
                            </span>
                          )}
                        </div>
                      </div>
                      <div className="form-group">
                        <label className="form-label" htmlFor="">
                          {t("User Message Color")}
                          <OverlayTrigger
                            key="right"
                            placement="right"
                            overlay={
                              <Tooltip>{t("User Message Color info")}</Tooltip>
                            }
                          >
                            <span className="ms-2 text-orange">
                              <i className="fa-solid fa-circle-question"></i>
                            </span>
                          </OverlayTrigger>
                        </label>
                        <div className="d-flex align-items-center justify-content-start gap-3">
                          <input
                            type="color"
                            className={`form-control form-control-color ${
                              errors.colorInput ? "is-invalid" : ""
                            }`}
                            id="color"
                            name="color"
                            // value={color}
                            title="Choose your color"
                            {...register("color", {
                              required: "Please select the color.",
                            })}
                            onChange={(event) => {
                              setColor(event.target.value);
                            }}
                          />
                          {errors.color && (
                            <span className="invalid-feedback">
                              {errors.color.message}
                            </span>
                          )}
                        </div>
                      </div>
                      <div className="form-group">
                        <label className="form-label">
                          {t("Align Chat Bubble Button")}
                          <OverlayTrigger
                            key="right"
                            placement="right"
                            overlay={
                              <Tooltip>
                                {t("Align Chat Bubble Button info")}
                              </Tooltip>
                            }
                          >
                            <span className="ms-2 text-orange">
                              <i className="fa-solid fa-circle-question"></i>
                            </span>
                          </OverlayTrigger>
                        </label>
                        <select
                          className={`form-select ${
                            errors.btnAlign ? "is-invalid" : ""
                          }`}
                          name="btnAlign"
                          id="btnAlign"
                          // value={btnAlign}
                          aria-label="Default select example"
                          {...register("btnAlign", {
                            required: "Please select the option.",
                          })}
                          onChange={(event) => {
                            setBtnAlign(event.target.value);
                          }}
                        >
                          <option>{t("Open this select menu")}</option>
                          <option value="Bottom left">
                            {t("Bottom Left")}
                          </option>
                          <option value="Bottom right">
                            {t("Bottom Right")}
                          </option>
                        </select>
                        {errors.btnAlign && (
                          <span className="invalid-feedback">
                            {errors.btnAlign.message}
                          </span>
                        )}
                      </div>
                      <div className="form-group">
                        <label className="form-label">
                          {t("Message Type")}
                          <OverlayTrigger
                            key="right"
                            placement="right"
                            overlay={<Tooltip>{t("Message Type")}</Tooltip>}
                          >
                            <span className="ms-2 text-orange">
                              <i className="fa-solid fa-circle-question"></i>
                            </span>
                          </OverlayTrigger>
                        </label>
                        <input
                          className={`form-control ${
                            errors.messageType ? "is-invalid" : ""
                          }`}
                          type="text"
                          name="messageType"
                          id="messageType"
                          // value={messageType}
                          {...register("messageType", {
                            required: "This field is required.",
                          })}
                          onChange={(event) =>
                            setMessageType(event.target.value)
                          }
                        />
                        {errors.messageType && (
                          <span className="invalid-feedback">
                            {errors.messageType.message}
                          </span>
                        )}
                      </div>
                      <button
                        type="submit"
                        className="button"
                        value="SUBMIT"
                        disabled={loading}
                      >
                        {loading ? <BtnLoader /> : t("SUBMIT")}
                      </button>
                    </Col>
                  </Row>
                </form>
              </div>
            </Col>
          </Row>
          {/* } */}
        </Container>
      </section>
    </>
  );
}
